import { clsx } from 'clsx';

import Container from '@/components/@base/container';
import { Text } from '@/components/@base/typography';
import XImage from '@/components/@base/x-image';
import { VOTE } from '@/components/app/product/components/@shared/type';

import imagesList from '@/constant/images-list';
import { pageLevelLocalization } from '@/constant/localization';
import CommentModel from '@/models/comment.model';

import LoadingAi from '~/images/icons/loadingAi';
import Star1 from '~/images/icons/star1';
import Star2 from '~/images/icons/star2';
import Vector from '~/images/icons/vector';

const { product: productLocalization } = pageLevelLocalization;

interface AiCommentProps {
  aiReviewSummary?: CommentModel;
  handleVote?: (id?: string, vote?: VOTE, isAi?: boolean) => void;
  isVotePending?: string;
}

export const AiComment = ({ aiReviewSummary, handleVote, isVotePending }: AiCommentProps) => {
  return (
    <div className={clsx('mb-6 gap-2.5 rounded-lg border-1 border-[#E9EBF1] bg-[#F2F3FF]')}>
      <Container className='flex flex-row items-center gap-2'></Container>
      <Container className='px-[25px]'>
        <Container className='w-full'>
          <Container className='relative w-full'>
            <Container className='mt-1 mb-8 flex h-8 flex-wrap items-center justify-start pt-4 md:mb-7 md:flex-nowrap md:pt-8'>
              <div className='relative h-8 w-8 overflow-hidden!'>
                <Container className='bg-ai' />
                <Vector className='absolute top-[34%] right-[33%]' />
                <Star1 className='absolute top-[12%] right-[20%]' />
                <Star2 className='absolute top-[22%] right-[11%]' />
              </div>
              <Text className='-mt-4 mr-2 ml-0.5 text-[15px] font-bold text-[#4D4A4A] md:mt-0'>
                {productLocalization.summaryOfBuyersViews}
              </Text>
              <Text className='-mt-3 mr-10 ml-0.5 text-[12px] text-[#ADADAD] md:mt-0 md:mr-2'>
                {productLocalization.createdByArtificialIntelligence}
              </Text>
            </Container>

            <Container className='text-[14px] leading-6 text-[#5B5C60]'>
              {aiReviewSummary?.description}
            </Container>
            <Container>
              <Container className='mt-[18px] mb-[25px] flex items-center justify-start gap-[11px]'>
                <Text className='text-[14px] font-bold text-[#4D4A4A]'>
                  {productLocalization.wasThisSummaryHelpful}
                </Text>

                <Container>
                  {isVotePending === aiReviewSummary?.id ? (
                    <Container className='flex h-[26px] w-[54px] items-center overflow-hidden rounded-md border border-[#E5E8EB] bg-white'>
                      <LoadingAi />
                    </Container>
                  ) : (
                    <Container className='flex h-[26px] w-[54px] items-center overflow-hidden rounded-md border border-[#E5E8EB] bg-white'>
                      <button
                        className='flex h-[26px] flex-1 cursor-pointer items-center justify-center hover:bg-[#F5F6F8]'
                        onClick={() => handleVote?.(aiReviewSummary?.id, VOTE.DISLIKE, true)}
                      >
                        <XImage src={imagesList.icons.dislike} alt='' />
                      </button>

                      <div className='h-3 w-px bg-[#E5E8EB]' />

                      <button
                        className='flex h-[26px] flex-1 cursor-pointer items-center justify-center hover:bg-[#F5F6F8]'
                        onClick={() => handleVote?.(aiReviewSummary?.id, VOTE.LIKE, true)}
                      >
                        <XImage src={imagesList.icons.like} alt='' />
                      </button>
                    </Container>
                  )}
                </Container>
              </Container>
            </Container>
          </Container>
        </Container>
      </Container>
    </div>
  );
};
